import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";

interface MenuNotPublishedPlaceholderProps {
    badgeText: string;
}

const MenuNotPublishedPlaceholder: React.FC<MenuNotPublishedPlaceholderProps> = ({ badgeText }) => {
    const { t } = useTranslation();

    return (
        <div className="h-100 d-flex">
            <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center border rounded-1 p-3">
                <Badge bg="violet-light" className="fs-7 text-primary lh-sm rounded-1 py-1 px-2 mb-2">
                    {t(badgeText)}
                </Badge>

                <p className="fs-7 text-grey text-center px-xxl-3 mb-0">
                    {t("Publish one of the menus so it becomes available to guests via QR code.")}
                </p>
            </div>
        </div>
    );
};

export default MenuNotPublishedPlaceholder;
